export const phoneMask = () => {
  return {
    mask: '000-000-000',
  };
};
